/** @format */

import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import Spacer from '../../Spacer';

import { ENV_COUNTRY } from '../../Hooks/Variables/Enviroment';
import { IMAGES } from '../../../../v2-config/constants/images.constant';

import './style.scss';
import { Service } from './service';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';

const SecondaryHeader = () => {

		const [modules, setModules] = useState([]);
	
		useEffect(() => {
			new Service()
				.getModulesByTemplate('home', 'ecommerce', Enviroment.ROOT_PHARMACY)
				.then((res) => {
					setModules(res.data);
				})
				.catch((err) => {
					console.error('Error cargando módulos:', err);
				});
		}, []);
		const pharmacyIcon = modules.find((m) => m.location === 'header-logo');
		const iconUrl = pharmacyIcon?.image;

	return (
		<>
			<div className="ph-header-secondary-space-vertical-container"></div>
			<div className={'ph-header-secondary-global-container'}>
				<div className="ph-header-secondary-main-container">
					<NavLink to="/">
						<img src={iconUrl ? iconUrl : IMAGES.FILE_NOT_AVAILABLE} alt="logo" className='ph-header-secondary-logo-image'/>
					</NavLink>
					<Spacer />
					<NavLink className={ENV_COUNTRY === 'AR' ? 'ph-header-secondary-button-arg' : 'ph-header-secondary-button'} to="/">
						Seguir Comprando
					</NavLink>
				</div>
			</div>
		</>
	);
};
export default SecondaryHeader;
